import React from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { Grid, Dialog, Button, SubmitButton, Debug, SearchSelect } from "../../../../../../";
import { makeStyles } from "@material-ui/styles";
import { Typography, Divider } from "@material-ui/core";
var useStyles = makeStyles(function (theme) {
  return {
    containerButtonsAttendance: {
      marginTop: "16px"
    },
    containerActions: {
      marginTop: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }
  };
});

var MobileDialogCampusCalendarCheckinSelectTypeCheckin = function MobileDialogCampusCalendarCheckinSelectTypeCheckin(props) {
  // console.log(
  //   "MobileDialogCampusCalendarCheckinSelectTypeCheckin props",
  //   props
  // );
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    open: props.open,
    onClose: props.onClose
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    align: "center"
  }, props.translation ? props.translation.title || "Check In" : "Check In"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    align: "center"
  }, props.data ? props.data.name || "" : "")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, props.translation ? props.translation.labels ? props.translation.labels.type || "Select option to continue" : "Select option to continue" : "Select option to continue"), /*#__PURE__*/React.createElement("div", {
    className: classes.containerButtonsAttendance
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    color: "primary",
    fullWidth: true,
    style: {
      marginBottom: "25px"
    },
    onClick: function onClick() {
      return props.handleSelectOption("group_change");
    }
  }, props.translation ? props.translation.buttons ? props.translation.buttons.group_change_check_in || "Comes from another group" : "Comes from another group" : "Comes from another group"), /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    color: "primary",
    fullWidth: true,
    onClick: function onClick() {
      props.handleSelectOption("entry");
    }
  }, props.translation ? props.translation.buttons ? props.translation.buttons.checkin || "Check In" : "Check In" : "Check In")))));
};

export { MobileDialogCampusCalendarCheckinSelectTypeCheckin };